<div
  class="toggle-icon"
  appToggleIcon
  [defaultState]="defaultState"
  (stateChange)="changedicon($event)"
>
  @for (icon of icons; track icon) {
  <label><i class="{{ icon }}"></i></label>
  }
</div>
